<!--
 * @Author: your name
 * @Date: 2021-06-21 16:09:10
 * @LastEditTime: 2021-08-26 14:18:51
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \zlt-front-end\src\TASMini\divs\Im\Im.vue
-->
<template>
  <div class="box">
    <ul>
      <li>
        <!-- <img src="https://img2.woyaogexing.com/2021/06/16/f9da9f4912134cdb9f4a4ad50bee36ba!400x400.jpeg" alt=""> -->
      </li>
      <li
        class="cursor"
        :class="msg == 0 ? 'selected' : 'normal'"
        @click="messAges_"
        id="0"
      >
        消息
      </li>
      <li
        class="cursor"
        :class="msg == 1 ? 'selected' : 'normal'"
        @click="messAges_"
        id="1"
      >
        分组
      </li>
       <li v-if="msg == 1">
          显示测试账号<a-switch v-model="showTestAccount"></a-switch>
      </li>
    </ul>
    <div class="friend-list1">
      <div v-show="msg == 0">
        <div class="refresh">
          <div @click="refresh">
            <img src="../../../assets/im/shua.png" alt="" />
          </div>
        </div>
        <div class="boxs">
          <div
            class="mian"
            v-for="(item, index) in friends"
            wx:key="index"
            @click="theValue(item)"
          >
            <div class="friends">
              <div class="friend-list-l">
                <div class="tip" v-if="item.unreadCount > 0">
                  {{ item.unreadCount }}
                </div>
                <img
                  :src="
                    item.userProfile.avatar ||
                    'https://zlt-2021.oss-cn-zhangjiakou.aliyuncs.com/eshop/2021/10/27/1564689964724129792.png'
                  "
                  alt=""
                />
              </div>
              <div class="friend-list-r">
                <div class="top">
                  <div
                    class="name"
                    :title="item.userProfile.userID + item.userProfile.nick"
                  >
                    {{ item.userProfile.nick
                    }}{{
                      item.userProfile.userID != "系统通知"
                        ? item.userProfile.userID
                        : ""
                    }}
                  </div>
                  <div class="time">
                    {{ item.lastMessage.lastTime | formatDate }}
                  </div>
                </div>
                <div class="news">{{ item.lastMessage.messageForShow }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-show="msg == 1">
        <!-- 分组 -->
        <a-tabs default-active-key="1" @change="callback">
          <a-tab-pane key="1" tab="客户">
               <div class="search">
                <div class="search_left">
                  <input
                    type="text"
                    v-model="searchKey"
                    placeholder="搜索筛选"
                    @keyup="searchFn"
                    ref="input"
                  />
                </div>
              </div>
              <div>
                <div v-show="showSearchState">
                  <div
                    v-for="(item, index) in searchList"
                    :key="index"
                    @click="theValue(item)"
                    class="lianxiren"
                  >
                    <div class="aa " v-if="" >
                      <div class="friend-list-l">
                        <!-- <div class="tip" v-if="item.unreadCount > 0">{{item.unreadCount}}</div> -->
                        <img :src="item.imageUrl" alt="" />
                      </div>
                      <div class="friend-list-rs">
                        <div class="top">
                          <div class="name">{{ item.imName }}*{{item.phone}}</div>
                          <!-- <div class="time">{{item.lastMessage.lastTime}}</div> -->
                        </div>
                        <div class="news">{{ item.imAccount }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            <div class="mianss" v-if="!showSearchState">
              <div v-for="(item, index) in grouping" :key="index">
                <div class="friends">
                  <div v-if="item.groupName == '我的客户'">
                    <div
                      class="lianxiren"
                      v-for="(itemA, index) in item.friendListModel"
                      :key="index"
                      @click="theValues(itemA)"
                    >
                      <div class="aa" v-if="">
                        <div class="friend-list-l">
                          <!-- <div class="tip" v-if="item.unreadCount > 0">{{item.unreadCount}}</div> -->
                          <img :src="itemA.imageUrl" alt="" />
                        </div>
                        <div class="friend-list-rs">
                          <div class="top">
                            <div class="name">{{ itemA.imName }}*{{itemA.phone}}</div>
                            <!-- <div class="time">{{item.lastMessage.lastTime}}</div> -->
                          </div>
                          <div class="news">{{ itemA.imAccount }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </a-tab-pane>
          <a-tab-pane key="2" :tab="tab" force-render>
            <div class="mianss">
              <div class="search">
                <div class="search_left">
                  <input
                    type="text"
                    v-model="input_value"
                    placeholder="搜索筛选"
                    @keyup="throttle"
                    ref="input"
                  />
                </div>
              </div>
              <div v-if="state">
                  <div  v-for="(item, index) in lists" :key="index" v-if="item">
                <div class="fold__items" v-if="!item.isTest || showTestAccount ">
                  <div @click="listDataClick2(index)" style="cursor:pointer" :class="item.isFund?'crownText':''">{{ item.groupName }} <span v-if="item.isTest" class="test">内测</span></div>
                  <div v-if="item.isSelect">
                    <div
                      v-for="(itemA, indexs) in item.friendListModel"
                      :key="indexs"
                      class="fold__item--content"
                      @click="theValues(itemA)"
                    >
                      <div class="friend-list-ls">
                        <img :src="itemA.imageUrl" alt="" />
                        <img class="crown" v-if="item.isFund"  src="../../../assets/images/crown45.png" alt="" srcset="" />
                      </div>
                      <div class="friend-list-rs">
                        <div class="top">
                          <div class="name" :class="item.isFund?'crownText':''">{{ itemA.imName }}*{{itemA.phone}}</div>
                        </div>
                        <div class="news" v-if="itemA.imName != null">
                          {{ itemA.imAccount }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              </div>
              <div v-show="aaa" v-for="(item, index) in dataList" :key="index">
                <div class="fold__items" v-if="!item.isTest || showTestAccount ">
                  <div @click="listDataClick(index)" style="cursor: pointer" :class="item.isFund?'crownText':''">
                    {{ item.groupName }} <span v-if="item.isTest" class="test">内测</span>
                  </div>
                  <div v-if="item.isSelect">
                    <div
                      v-for="(itemA, indexs) in item.friendListModel"
                      :key="indexs"
                      class="fold__item--content"
                      @click="theValues(itemA)"
                    >
                      <div class="friend-list-ls">
                        <img :src="itemA.imageUrl" alt="" />
                        <img class="crown" v-if="item.isFund" src="../../../assets/images/crown45.png" alt="" srcset="" />
                      </div>
                      <div class="friend-list-rs">
                        <div class="top">
                          <div class="name" :class="item.isFund?'crownText':''">{{ itemA.imName }}*{{itemA.phone}}</div>
                        </div>
                        <div class="news" v-if="itemA.imName != null">
                          {{ itemA.imAccount }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </a-tab-pane>
          <a-tab-pane key="3" tab="团队">
            <div
              class="mianss"
              v-for="(item, index) in grouping"
              wx:key="index"
            >
              <div class="friends">
                <div v-if="item.groupName == '我的同事'">
                  <div
                    class="lianxiren"
                    v-for="(itemA, index) in item.friendListModel"
                    :key="index"
                    @click="theValues(itemA)"
                  >
                    <div class="aa">
                      <div class="friend-list-l">
                        <!-- <div class="tip" v-if="item.unreadCount > 0">{{item.unreadCount}}</div> -->
                        <img :src="itemA.imageUrl" alt="" />
                      </div>
                      <div class="friend-list-rs">
                        <div class="top">
                          <div class="name">{{ itemA.imName }}*{{itemA.phone}}</div>
                          <!-- <div class="time">{{item.lastMessage.lastTime}}</div> -->
                        </div>
                        <div class="news">{{ itemA.imAccount }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </a-tab-pane>
        </a-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import { eventBus } from "../../../utils/eventBus.js";
import datas from "../information.js";
import Peo from "../components/product.vue";
import { formatDate } from "../time.js";
import {
  getGroupFriend,
  getOrgGroupFriend,
  queryByUser,
} from "../../../api/im.js";
export default {
  filters: {
    formatDate(time) {
      time = time * 1000;
      let date = new Date(time);
      console.log(new Date(time));
      return formatDate(date, "yyyy-MM-dd hh:mm");
    },
  },
  data() {
    return {
      showTestAccount:false,
        searchKey:'',
    showSearchState:false,
    searchList:[],
      msg: 0,
      friends: [],
      list: null,
      messages: null,
      grouping: [], //分组
      lists: null,
      dataList: [], //供应商分组
      showIndex: -1,

      input_value: "",
      state: false,
      statu: true,
      aaa: true,
      lists: [],
      tab:""
    };
  },
  components: {
    Peo,
  },
  mounted() {
    // 如果没有账号
    if (
      !localStorage.getItem("imAccount") ||
      !localStorage.getItem("userSig")
    ) {
      this.$tim.logout();
      queryByUser().then((res) => {
        console.log(res, "7777777777777777777777777777777");
        localStorage.setItem("imAccount", res.data.imAccount);
        localStorage.setItem("userSig", res.data.userSig);
        localStorage.setItem("accountType", res.data.accountType);

        this.init();
      });
      return;
    }
    this.init();

    // }, 500);
  },
  methods: {
      searchFn(){
          var key = this.searchKey;
          var showSearchState = false,lists = []
    if (key.length > 0) {
      showSearchState = true;     
    } else {
      showSearchState = false;     
    }

    //循环模拟数据的数组
    this.grouping.map((msg) => {
      msg.friendListModel.map((item) => {
        if(msg.groupName == '我的客户'){        
        if (
          (item.imAccount &&
            item.imAccount.indexOf(key) != -1) ||
          (item.imName && item.imName.indexOf(key) != -1) ||
          (item.phone && item.phone.indexOf(key) != -1) ||
          (item.brandName &&
            item.brandName.indexOf(key) != -1) ||
          (item.storeName &&
            item.storeName.indexOf(key) != -1) ||
          (item.groupName && item.groupName.indexOf(key) != -1)
        ) {
          lists.push(item);
        }
      }
      });
    });
   
      this.showSearchState=showSearchState,
      this.searchList=lists
    
      },
    init() {
      if (localStorage.getItem("accountType") == 2) {
        this.tab = "供应商";
      } else {
        this.tab = "门店";
      }
      var that = this;
      // console.log(that.$TIMS.EVENT.MESSAGE_RECEIVED, 'uuuuuuuuuuuuuu')
      that.$tim.on(that.$TIMS.EVENT.MESSAGE_RECEIVED, (event) => {
        // console.log(event, '新消息')
        that.initRecentContactList();
      });
      // console.log('==========================')
      this.friends = datas.friends();
      // setTimeout(() => {
      // 拉取会话列表
      that.initRecentContactList();
      setTimeout(function () {
        that.initRecentContactList();
      }, 1000);

      this.getGroupFriend(); //获取好友列表
      this.getOrgGroupFriend(); //获取供应商列表
    },
    // 输入框
    search() {
      //这个变量主要是用来测试节流后和不节流的区别
      var i = 0;
      console.log(i++);
      //定义的新数组存放筛选之后的数据
      this.lists = [];
      //拿到当前input输入框输入的值
      this.input_value = this.$refs.input.value;
      //判断展示ul列表，如果输入了就展示没输入就不展示
      if (this.input_value.length > 0) {
        this.state = true;
        this.aaa = false;
      } else {
        this.state = false;
        this.aaa = true;
      }

      //循环模拟数据的数组
      this.dataList.map((msg,index) => {
        msg.friendListModel.map((item) => {
          if (
            (item.imAccount &&
              item.imAccount.indexOf(this.input_value) != -1) ||
            (item.imName && item.imName.indexOf(this.input_value) != -1) ||
            (item.phone && item.phone.indexOf(this.input_value) != -1) ||
            (item.brandName &&
              item.brandName.indexOf(this.input_value) != -1) ||
            (item.storeName &&
              item.storeName.indexOf(this.input_value) != -1) ||
            (item.groupName && item.groupName.indexOf(this.input_value) != -1)
          ) {
           if(!this.lists[index]){
              this.lists[index] = {
                friendListModel:[],
                groupName:msg.groupName,
                isSelect:false,
                isTest:msg.isTest
              }
            }
            this.lists[index].friendListModel.push(item);
          }
        });
      });
    },
    //节流函数
    throttle() {
      //保持this的指向始终指向vue实例
      var that = this;
      if (!that.statu) {
        return;
      }
      that.statu = false;
      setTimeout(function () {
        console.log(new Date());
        that.search();
        that.statu = true;
      }, 1000);
    },

    // 获取会话列表
    initRecentContactList() {
      var that = this;
      // console.log(this.$tim, 'time22')
      //如果没有账号 重新获取一下账号

      let promise2 = this.$tim.login({
        userID: localStorage.getItem("imAccount"),
        userSig: localStorage.getItem("userSig"),
      });
      promise2
        .then(function (imResponse) {
          console.log(imResponse, '登陆成功')
        })
        .catch(function (imError) {
          console.log(imError, '登陆失败')
          // util.sLoadingHide()
        });
      let promise = that.$tim.getConversationList();
      promise
        .then(function (imResponse) {
          // console.log(imResponse, '获取会话列表接口res')
          const conversationList = imResponse.data.conversationList; // 会话列表，用该列表覆盖原有的会话列表
          // console.log(conversationList, '====获取会话列表接口=======')
          that.friends = conversationList;
          var aa = 0;
          that.friends.forEach((item) => {
            // console.log(item.unreadCount, '---------消息未读数---------')
            aa += item.unreadCount;
            localStorage.setItem("unreadCount", aa);
          });
          // console.log(that.friends,'8888888888888888888')
        })
        .catch(function (imError) {
          console.warn("getConversationList error:", imError); // 获取会话列表失败的相关信息
        });
    },

    callback(key) {
      console.log(key);
    },
    messAges_(e) {
      console.log(e.target.id, "=======");
      if (this.msg == e.target.id) {
        return false;
      } else {
        this.msg = e.target.id;
      }
    },
    // 点击某个好友
    theValue(e) {
      var that = this;
      // console.log(e)
      this.list = e;
      // console.log(this.friends, '=========')
      eventBus.$emit("aa", this.list);
      // setTimeout(() => {
      this.getMessage();
      // }, 500)
      // console.log(this.list, '----------------')
      let promise = that.$tim.setMessageRead({
        conversationID: this.list.conversationID,
      });
      promise
        .then(function (imResponse) {
          // console.log(imResponse, '消息是否已读')
          that.initRecentContactList();
          // 已读上报成功，指定 ID 的会话的 unreadCount 属性值被置为0
        })
        .catch(function (imError) {
          // 已读上报失败
          console.warn("setMessageRead error:", imError);
        });
    },

    // 点击分组好友
    theValues(e) {
      // console.log(e, '[ppppppppppppp')
      this.list = e;
      // setTimeout(() => {
      this.getMessage();
      // }, 500)
      eventBus.$emit("aa", this.list);
    },
    // 获取历史消息
    getMessage() {
      var that = this;
      if (that.list != "") {
        var conversationID = "";
        if (that.list && that.list.conversationID) {
          conversationID = that.list.conversationID;
        } else if (that.list && that.list.imAccount) {
          conversationID = "C2C" + that.list.imAccount;
        } else if (that.list) {
          conversationID = "C2C" + that.list;
        } else {
          conversationID = "";
        }
        let promise = that.$tim.getMessageList({
          conversationID: conversationID,
          count: 1000,
        });
        console.log(
          that.list
            ? that.list.conversationID
              ? that.list.conversationID
              : "C2C" + that.list
            : "",
          "888888888888888888888888888888888888"
        );
        promise.then(function (imResponse) {
          const messageList = imResponse.data.messageList; // 消息列表。
          // console.log(messageList, '消息列表')
          that.messages = messageList;
          that.messages.forEach((item) => {
            if (item.type == "TIMCustomElem") {
              if (item.payload.data && item.payload.data != "[object Object]") {
                item.payload.data = JSON.parse(item.payload.data);
              }
            }
          });
          // that.messages = messageList
          // console.log(that.messages, '========')
          // that.messages = messageList
          // console.log(that.messages, '-----------------')
          eventBus.$emit("bb", that.messages);
          // that.pageScrollToBottom()
          // var currenttime= res.data.timeStamp;
          // that.data.timWx.formatTime(that.data.message.time, 'Y/M/D h:m:s')
          // console.log(that.data.message[0].payload.text,'消息列表')
          const nextReqMessageID = imResponse.data.nextReqMessageID; // 用于续拉，分页续拉时需传入该字段。
          const isCompleted = imResponse.data.isCompleted; // 表示是否已经拉完所有消息。
        });
      }
    },

    // 获取好友列表
    getGroupFriend() {
      var that = this;
      var data = {
        from_Account: localStorage.getItem("imAccount"),
        needFriend: "Need_Friend_Type_Yes",
        lastSequence: 0,
      };
      getGroupFriend(data).then((res) => {
        that.grouping = res.groupListModel;
        // console.log(that.grouping, '88888888888')
      });
    },

    // 获取供应商列表
    getOrgGroupFriend() {
      var that = this;
      var data = {
        from_Account: localStorage.getItem("imAccount"),
        needFriend: "Need_Friend_Type_Yes",
        lastSequence: 0,
      };
      getOrgGroupFriend(data).then((res) => {
        // console.log(res, '00000000000000000000000000000000')
        that.dataList = res;
        that.dataList.forEach((item) => {
          item.isSelect = false;
        });
        // console.log(that.dataList, '供应商')
      });
    },

    // 折叠面板
    listDataClick(e) {
      this.dataList.forEach((item, index) => {
        if (e == index) {
          // console.log(e,index)
          item.isSelect = !item.isSelect;
          // console.log(item.isSelect)
        }
      });
      // console.log(this.dataList,'=========')
      this.dataList = JSON.parse(JSON.stringify(this.dataList));

      console.log(e, "点击下标");
    },
       listDataClick2(e) {
      this.lists.forEach((item, index) => {
        if (e == index) {
          // console.log(e,index)
          item.isSelect = !item.isSelect;
          // console.log(item.isSelect)
        }
      });
      // console.log(this.dataList,'=========')
      this.lists = JSON.parse(JSON.stringify(this.lists));
  
      console.log(e, "点击下标");
    },

    // 刷新
    refresh() {},
  },
};
</script>
<style scoped>
* {
  list-style-type: none;
  margin: 0;
  padding: 0;
}

.box {
  display: flex;
  flex-direction: row;
  width: 100%;
}

ul {
  width: 22%;
  height: 654px;
  /* border: 1px solid #f90; */
  background-color: #303841;
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
}

li {
  width: 100%;
  height: 70px;
  /* border: 1px solid #f90; */
  text-align: center;
  padding: 22px 0 0 0;
  color: #bbbbbb;
}

.friend-list1 {
  width: 78%;
  height: 654px;
  border: 1px solid #ccc;
}

.selected {
  background-color: rgb(110, 110, 110);
  border-left: 3px solid #47b8e5;
  font-weight: bold;
  color: #fffffe;
}

.normal {
  border-left: 3px solid #303841;
  /* font-weight: bold; */
  /* color: #fffffe; */
  /* border: 1px solid #303841; */
}

.boxs {
  width: 100%;
  /* height: 100%; */
  height: 610px;
  /* border: 1px solid #f90; */
  overflow-y: auto;
}

.mian {
  width: 100%;
  height: 60px;
  /* border: 1px solid #f90; */
  padding: 5px;
  cursor: pointer;
}
.boxs::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 5px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}

.boxs::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  box-shadow: inset 0 0 5px rgb(201, 201, 201);
  background: rgb(201, 201, 201);
}

.boxs::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgb(201, 201, 201);
  border-radius: 5px;
  background: #ededed;
}

.friend-list {
  /* border: 1xp solid #f90; */
  background: #fffffe;
  padding: 30px 10px;
}

.mian:hover {
  background-color: rgb(214, 214, 214);
}

.friend-list-l {
  float: left;
  position: relative;
  width: 20%;
  height: 50px;
  /* border: 1px solid #333; */
}

.friend-list-l img {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  margin-top: 5px;
  /* margin-left: 18px; */
}

.friend-list-rs {
  padding-left: 15px;
}

.tip {
  position: absolute;
  z-index: 20;
  top: -3px;
  left: 40px;
  height: 18px;
  min-width: 18px;
  font-size: 12px;
  color: #fffffe;
  line-height: 18px;
  text-align: center;
  background: #e24444;
  border-radius: 16px;
}

.friend-list-r {
  width: 100%;
  height: 60px;
  /* border: 1px solid #333; */
}

.name {
  float: left;
  font-size: 14px;
  font-weight: 400;
  color: #333;
  line-height: 22px;
}

.time {
  float: right;
  font-size: 20rpx;
  color: rgb(190, 190, 190);
  line-height: 50rpx;
}

.news {
  font-size: 25rpx;
  color: rgb(167, 167, 167);
  line-height: 40rpx;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  height: 25px;
}

.friends {
  /* display: flex;
        flex-direction: row; */
}

.top {
  height: 25px;
}

.fold__panel {
  padding-left: 15px;
  padding-right: 15px;
}

.fold__items {
  background: #ffffff;
  box-shadow: -6px 0px 20px 0px #e7e7e7;
  border-radius: 10px;
  margin: 0 5px;
  margin-bottom: 20px;
  padding: 10px;
}
.fold__item--content {
  margin-top: 5px;
  transition: all 0.4s;
  display: flex;
  flex-direction: row;

  border-radius: 10px;
  padding: 5px;
  cursor: pointer;
}
.fold__item--content:hover {
  background-color: rgb(214, 214, 214);
}
.friend-list-ls {
  float: left;
  position: relative;
  width: 30%;
  height: 52px;
}

.friend-list-ls img {
  width: 50px;
  height: 50px;
  border-radius: 8px;
  margin-top: 0px;
  /* margin-left: 18px; */
}
.crown{
  position: absolute;
  top:-15px;
  left:35px;
  width: 28px !important;
  height: 24px !important;
}
.crownText{
  color: #FEBF01 !important;
}

.friend-list-rs {
  padding-left: 0px;
}

.top {
  height: 25px;
}

.name {
  float: left;
  font-size: 14px;
  font-weight: 400;
  color: #333;
  cursor: pointer;
  line-height: 22px;
  width: 125px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  white-space: nowrap;
  overflow: hidden;
}

.refresh {
  width: 100%;
  height: 40px;
}

.refresh div {
  width: 35px;
  height: 35px;
  border-radius: 5px;
  /* background-color: #d1d1d1; */
  float: right;
  margin: 2px 10px 0 0;
  cursor: pointer;
}

.refresh img {
  width: 32px;
  height: 32px;
  padding: 3px;
  margin: 1px 0 0 2px;
}

.mianss {
  width: 100%;
  height: 590px;
  padding-top: 0px;
  overflow-y: auto;
}
.lianxiren {
  cursor: pointer;
  padding: 0px 10px;
}
.lianxiren:hover {
  background-color: rgb(214, 214, 214);
}
.mianss::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 5px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}

.mianss::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  box-shadow: inset 0 0 5px rgb(201, 201, 201);
  background: rgb(201, 201, 201);
}

.mianss::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgb(201, 201, 201);
  border-radius: 5px;
  background: #ededed;
}

.aa {
  display: flex;
  flex-direction: row;
  padding: 0 10px;
}

.search {
  width: 100%;
  height: 50px;
  display: flex;
  flex-direction: row;
}

.search_left {
  width: 100%;
  margin: 0 5px;
}

.search_left input {
  width: 100%;
  height: 30px;
  border: 1px solid rgb(211, 211, 211);
  margin: 0px 0 0 0px;
  border-radius: 8px;
  outline-style: none;
  padding: 0 0 0 4px;
}

.search_right div {
  width: 50px;
  line-height: 30px;
  border-radius: 5px;
  background-color: rgb(106, 214, 120);
  color: #fffffe;
  font-size: 15px;
  text-align: center;
  margin: 10px 0 0 20px;
  cursor: pointer;
}
.cursor {
  cursor: pointer;
}
.test{
  display: inline-block;
  width: 36px;
  height: 16px;
  font-size: 13px;
  line-height: 16px;
  background: #676769ee;
  color: #fffffe;
  text-align: center;
  border-radius: 20px;
  margin: 0 0 0 5px;
}
</style>


// WEBPACK FOOTER //
// src/TASMini/views/Im/components/tab.vue